import { render, staticRenderFns } from "./check-result.vue?vue&type=template&id=df934ab6&"
import script from "./check-result.vue?vue&type=script&lang=js&"
export * from "./check-result.vue?vue&type=script&lang=js&"
import style0 from "./check-result.vue?vue&type=style&index=0&id=df934ab6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports